import { useFormContext } from 'react-hook-form';
import QuotePricePackageWrapper from '../../../quote-price-package-wrapper';
import css from './index.module.scss';

const DomesticQuotePrices = (props: any) => {
  const {
    totalWeight,
    totalWeightUnit,
    totalLocalFreightPrice,
    totalLocalFreightCurrency,
    basePrice,
    basePriceCurrency,
    basePriceWeightUnit,
    warehousingCostCurrency,
    warehousingCostPrice,
    selectedWeightSystemChildOptions,
    selectedCurrency,
    basePriceWeightUnitWatch
  } = props;

  const { control } = useFormContext();

  return (
    <>
      <div className={css.rowWrapper}>
        <QuotePricePackageWrapper
          label="Base Price"
          control={control}
          input={basePrice}
          inputRequired={true}
          inputPlaceholder="Enter Price"
          unit={basePriceWeightUnit}
          unitPlaceholder="Per Unit"
          unitOptions={selectedWeightSystemChildOptions}
          currency={basePriceCurrency}
          currencyOptions={selectedCurrency}
          currencyPlaceholder="Currency"
        />
        <QuotePricePackageWrapper
          label="Total Transportation & Freight"
          currencyPlaceholder="Currency"
          inputPlaceholder="Enter Price"
          input={totalLocalFreightPrice}
          currency={totalLocalFreightCurrency}
          control={control}
          currencyOptions={selectedCurrency}
        />
      </div>
      <div className={css.rowWrapper}>
        <QuotePricePackageWrapper
          label="Warehousing Cost"
          currencyPlaceholder="Currency"
          inputPlaceholder="Enter Price"
          input={warehousingCostPrice}
          currency={warehousingCostCurrency}
          control={control}
          currencyOptions={selectedCurrency}
        />
        <QuotePricePackageWrapper
          label="Total weight"
          unitPlaceholder="Unit"
          inputPlaceholder="Enter Weight"
          input={totalWeight}
          unit={totalWeightUnit}
          control={control}
          unitOptions={selectedWeightSystemChildOptions}
          inputRequired={true}
        />
      </div>
    </>
  );
};

export default DomesticQuotePrices;
